const enhanceProductUpdateFilter = () => {
  const filter = document.querySelector('[data-update-filter]')
  if (!filter) return

  const container = filter.parentElement
  const buttons = [...filter.querySelectorAll('button[data-product]')]
  const entries = [...container.querySelectorAll('article.update')].map(article => ({
    article, products: article.dataset.products.split(' ')
  }))
  const years = [...container.querySelectorAll('details.update-year')].map(element => ({
    element, articles: [...element.querySelectorAll('article.update')],
    count: element.querySelector('[data-year-count]')
  }))

  const hashTarget = () => {
    try {
      return document.getElementById(decodeURIComponent(window.location.hash.slice(1)))
    } catch {
      return null
    }
  }

  const linkedEntryForHash = () => {
    const target = hashTarget()
    return entries.find(entry => entry.article.contains(target))
  }

  const revealHash = () => {
    const target = hashTarget()
    const year = target?.closest('details.update-year')
    if (!year || year.hidden) return
    year.open = true
    target.scrollIntoView()
  }

  const apply = (requested, { honorHash = false } = {}) => {
    let product = buttons.some(button => button.dataset.product === requested) ? requested : ''
    const url = new URL(window.location.href)
    const linkedEntry = url.hash ? linkedEntryForHash() : null
    const linkedYear = hashTarget()?.closest('summary')?.parentElement
    const hidesLinkedEntry = linkedEntry && !linkedEntry.products.includes(product)
    const hidesLinkedYear = linkedYear && !entries.some(entry => linkedYear.contains(entry.article) && entry.products.includes(product))
    if (product && (hidesLinkedEntry || hidesLinkedYear)) {
      if (honorHash) product = ''
      else url.hash = ''
    }

    entries.forEach(entry => {
      const hidden = Boolean(product && !entry.products.includes(product))
      entry.article.hidden = hidden
    })
    years.forEach(year => {
      const count = year.articles.filter(article => !article.hidden).length
      year.element.hidden = count === 0
      year.count.firstChild.textContent = String(count)
      year.count.querySelector('.sr-only').textContent = count === 1 ? ' update' : ' updates'
    })
    buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.product === product)))

    if (product) url.searchParams.set('product', product)
    else url.searchParams.delete('product')
    if (url.href !== window.location.href) window.history.replaceState(window.history.state, '', url)
  }

  const applyLocation = () => {
    apply(new URL(window.location.href).searchParams.get('product'), { honorHash: true })
    revealHash()
  }
  buttons.forEach(button => button.addEventListener('click', () => apply(button.dataset.product)))
  window.addEventListener('popstate', applyLocation)
  window.addEventListener('hashchange', applyLocation)
  applyLocation()
  filter.hidden = false
}

document.addEventListener('DOMContentLoaded', enhanceProductUpdateFilter)
